<p-toast></p-toast>

<div class="ed" *ngIf="event">
  <!-- En-tête : le verdict d'abord -->
  <header class="ed-head">
    <div class="ed-head-top">
      <span class="ed-badge" [class.ed-badge-urgent]="urgency() === 'urgent'" [class.ed-badge-soon]="urgency() === 'soon'">
        {{ daysUntil() === 0 ? ('eventDetail.today' | translate) : ('eventDetail.inDays' | translate: { days: daysUntil() }) }}
      </span>
      <span class="ed-sport">{{ event.sportTitle }}</span>
      <button type="button" class="ed-share" (click)="copyToClipBoard()">
        <i class="pi pi-link"></i> {{ 'eventDetail.copyLink' | translate }}
      </button>
      <button type="button" class="ed-share" [disabled]="buildingStory()" (click)="downloadStory()">
        <i class="pi" [ngClass]="buildingStory() ? 'pi-spin pi-spinner' : 'pi-instagram'"></i>
        {{ 'eventDetail.storyCta' | translate }}
      </button>
    </div>
    <h2 class="ed-title">{{ event.title }}</h2>
    <p class="ed-meta">
      <span><i class="pi pi-calendar"></i> {{ event.startDate | date: 'EEEE d MMMM y, HH:mm' }}</span>
      <span *ngIf="event.duration"><i class="pi pi-clock"></i> {{ event.duration }}</span>
      <span><i class="pi pi-map-marker"></i> {{ event.locationAddress || event.location.name }}</span>
      <span *ngIf="!event.acceptAnyLvl && event.level"><i class="pi pi-chart-bar"></i> {{ 'eventDetail.level' | translate }} {{ event.level }}</span>
      <span *ngIf="event.acceptAnyLvl"><i class="pi pi-chart-bar"></i> {{ 'eventDetail.anyLevel' | translate }}</span>
    </p>
  </header>

  <!-- Remplissage : hors organisateur, toujours -->
  <section class="ed-card ed-fill">
    <div class="ed-fill-row">
      <span class="ed-fill-figure" [class.ed-fill-empty]="partners() === 0">
        {{ partners() }}<span class="ed-fill-cap">/{{ partnerCapacity() }}</span>
      </span>
      <span class="ed-fill-label">{{ 'eventDetail.partnersSeats' | translate }}</span>
      <div class="ed-gauge"><div class="ed-gauge-bar" [class.ed-gauge-alert]="partners() === 0" [style.width]="fillWidth()"></div></div>
    </div>
    <p class="ed-note">{{ 'eventsList.fillNote' | translate }}</p>
  </section>

  <!-- Engager : le composeur de campagne -->
  <section class="ed-card ed-engage">
    <h3>{{ 'eventDetail.engageTitle' | translate }}</h3>
    <ng-container *ngIf="around() as ctx">
      <p class="ed-engage-line" [innerHTML]="'eventDetail.engageAround' | translate: { total: ctx.total, radius: ctx.radiusInKm }"></p>
      <p class="ed-engage-line ed-engage-sport" *ngIf="ctx.sameSport !== null" [innerHTML]="'eventDetail.engageSameSport' | translate: { count: ctx.sameSport, sport: ctx.sportName || event.sportTitle }"></p>
    </ng-container>

    <div class="ed-composer" *ngIf="previewCount() !== null || previewLoading()">
      <div class="ed-composer-row">
        <span class="ed-composer-label">{{ 'eventDetail.radiusLabel' | translate }}</span>
        <div class="ed-radius-chips">
          <button *ngFor="let r of radiusOptions" type="button" class="ed-chip"
            [class.ed-chip--on]="radiusKm() === r" (click)="setRadius(r)">{{ r }} km</button>
        </div>
      </div>

      <div class="ed-composer-row">
        <span class="ed-composer-label">{{ 'eventDetail.sportLabel' | translate }}</span>
        <div class="ed-radius-chips">
          <button type="button" class="ed-chip" [class.ed-chip--on]="!anySport()" (click)="anySport() && toggleAnySport()">{{ event.sportTitle }}</button>
          <button type="button" class="ed-chip" [class.ed-chip--on]="anySport()" (click)="!anySport() && toggleAnySport()">{{ 'eventDetail.allSports' | translate }}</button>
        </div>
      </div>

      <div class="ed-composer-row">
        <span class="ed-composer-label">{{ 'eventDetail.levelLabel' | translate }}</span>
        <select class="ed-select" [value]="levelMin() ?? ''" (change)="setLevelMin($any($event.target).value)">
          <option value="">{{ 'eventDetail.levelAny' | translate }}</option>
          <option *ngFor="let l of levelOptions" [value]="l">{{ 'eventDetail.levelFrom' | translate }} {{ l }}</option>
        </select>
        <select class="ed-select" [value]="levelMax() ?? ''" (change)="setLevelMax($any($event.target).value)">
          <option value="">{{ 'eventDetail.levelAny' | translate }}</option>
          <option *ngFor="let l of levelOptions" [value]="l">{{ 'eventDetail.levelTo' | translate }} {{ l }}</option>
        </select>
      </div>

      <div class="ed-composer-row ed-composer-channels">
        <span class="ed-composer-label">{{ 'eventDetail.channelsLabel' | translate }}</span>
        <label class="ed-check">
          <input type="checkbox" [checked]="channelInvitation()" (change)="toggleChannel('invitation')" />
          <span><strong>{{ 'eventDetail.channelInvitation' | translate }}</strong><br /><small>{{ 'eventDetail.channelInvitationHint' | translate }}</small></span>
        </label>
        <label class="ed-check">
          <input type="checkbox" [checked]="channelProximityPush()" (change)="toggleChannel('proximityPush')" />
          <span><strong>{{ 'eventDetail.channelPush' | translate }}</strong><br /><small>{{ 'eventDetail.channelPushHint' | translate }}</small></span>
        </label>
        <label class="ed-check ed-check--disabled">
          <input type="checkbox" disabled />
          <span><strong>{{ 'eventDetail.channelEmail' | translate }}</strong><br /><small>{{ 'eventDetail.channelEmailHint' | translate }}</small></span>
        </label>
      </div>

      <p class="ed-preview" *ngIf="!previewLoading(); else previewSpin">
        <span [innerHTML]="'eventDetail.previewCount' | translate: { count: previewCount() ?? 0 }"></span>
      </p>
      <ng-template #previewSpin><p class="ed-preview ed-preview--loading">{{ 'eventDetail.previewLoading' | translate }}</p></ng-template>

      <div class="ed-engage-actions" *ngIf="!campaignResult()">
        <button pButton pRipple type="button" [loading]="sending()"
          [disabled]="!canSend"
          [icon]="sendArmed() ? 'pi pi-exclamation-triangle' : 'pi pi-send'"
          [label]="(sendArmed() ? 'eventDetail.confirmSend' : 'eventDetail.send') | translate: { count: previewCount() ?? 0 }"
          [class.p-button-warning]="sendArmed()"
          (click)="sendCampaign()"></button>
        <button *ngIf="sendArmed()" pButton type="button" class="p-button-text"
          [label]="'eventDetail.cancelSend' | translate" (click)="sendArmed.set(false)"></button>
      </div>

      <p class="ed-campaign-result" *ngIf="campaignResult() as res">
        <i class="pi pi-check-circle"></i>
        {{ 'eventDetail.resultLine' | translate: { invited: res.invited, pushed: res.pushNotified } }}
      </p>
      <p class="ed-campaign-error" *ngIf="campaignError()">{{ 'eventDetail.sendFailed' | translate }}</p>
    </div>

    <div class="ed-engage-actions" *ngIf="around()">
      <button pButton pRipple type="button" icon="pi pi-download" class="p-button-outlined"
        [loading]="exporting()"
        [label]="('eventDetail.exportCta' | translate: { count: (around()?.sameSport ?? around()?.total) ?? 0 })"
        (click)="exportAround()"></button>
    </div>
    <p class="ed-note">{{ 'eventDetail.pushNote' | translate }}</p>
  </section>

  <!-- Participants -->
  <section class="ed-card">
    <h3>{{ 'eventDetail.participants' | translate }} ({{ event.nbAttendees }})</h3>
    <ul class="ed-attendees" *ngIf="event.attendees?.length; else noAttendees">
      <li *ngFor="let attendee of event.attendees">
        <span class="ed-attendee-mail">{{ attendee.email }}</span>
        <a [routerLink]="['/users', attendee.id]" class="ed-attendee-link">
          <i class="pi pi-user"></i> {{ 'eventDetail.viewProfile' | translate }}
        </a>
      </li>
    </ul>
    <ng-template #noAttendees>
      <p class="ed-note">{{ 'eventDetail.noAttendees' | translate }}</p>
    </ng-template>
    <p class="ed-note">{{ 'eventDetail.attendeesNote' | translate }}</p>
  </section>

  <!-- Description -->
  <section class="ed-card" *ngIf="event.description">
    <h3>{{ 'eventDetail.description' | translate }}</h3>
    <p class="ed-description">{{ event.description }}</p>
  </section>

  <!-- Carte -->
  <section class="ed-card ed-map" *ngIf="event.location">
    <google-map width="100%" height="240px" [options]="options">
      <map-marker [position]="markerPositions"></map-marker>
    </google-map>
  </section>
</div>
